import { Alert } from '@mui/material';
import React, { ReactNode } from 'react';

export interface CreateExerciseErrorProps {
  error?: ReactNode;
}

const CreateExerciseError = ({
  error = (
    <>
      Unfortunately a technical issue prevented the simulation from starting.
      <br />
      Please try again soon!
    </>
  ),
}: CreateExerciseErrorProps) => <Alert severity="error">{error}</Alert>;

export default CreateExerciseError;
